import { Reveal } from "../components/Reveal";
import { FACTS } from "../data/site";

// Verified DCC track record — every figure reads from the central FACTS
// object (data/site.js). Final values are always in the DOM: no count-up
// from zero, so the numbers are readable by users, crawlers and screen
// readers from first render.
const ORDER = ["marriottProperties", "clientsServed", "sitesPerMonth", "yearsExperience"];

export function CredibilityBar() {
  return (
    <section className="bg-white" aria-label="DCC track record">
      <div className="container-x">
        <div className="border border-zinc-200">
          <div className="grid grid-cols-1 divide-y divide-zinc-200 sm:grid-cols-2 sm:gap-px sm:divide-y-0 sm:bg-zinc-200 lg:grid-cols-4">
            {ORDER.map((key, i) => {
              const s = FACTS[key];
              return (
                <Reveal key={key} delay={i * 0.06} y={12} className="h-full">
                  <div data-testid={`credibility-${key}`} className="flex h-full items-center gap-5 bg-white px-6 py-9 md:py-12">
                    <span className="h-display text-5xl text-dcc md:text-6xl" aria-label={`${s.value}${s.suffix} ${s.label}`}>
                      {s.value}{s.suffix}
                    </span>
                    <span>
                      <span className="block text-sm font-bold text-charcoal md:text-base">{s.label}</span>
                      <span className="mt-1 block font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">{s.caption}</span>
                    </span>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
